import { AsyncPipe } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CategoryRecord } from "b2b-ecommerce-lib";
import { ButtonDirective } from "primeng/button";
import { Observable } from "rxjs";
import { CatalogService } from "../../services/catalog.service";
import { SessionService } from "../../services/login.service";
import { ThemeService } from "../../services/theme.service";

@Component({
  selector: "app-footer",
  template: `
    <footer class="bg-primary text-primary-contrast">
      <div class="container w-full py-16 pb-8">
        <img
          [src]="'assets/images/sapientialogo_footer_light.png'"
          alt="Sapientia Logo"
          class="mb-8 h-[65px] w-[247px]"
        />
        <div class="xl:grid xl:grid-cols-2 xl:gap-8">
          <div class="grid grid-cols-2 gap-8 xl:col-span-2">
            <div class="md:grid md:grid-cols-2 md:gap-4 lg:gap-8">
              <div>
                <h3 class="w-fit border-b-1 pb-2 text-xl font-semibold">
                  {{ "footer.Products" | translate }}
                </h3>
                <ul role="list" class="mt-3 space-y-2">
                  @for (categoria of categories$ | async; track $index) {
                    <li>
                      <a
                        class="cursor-pointer text-sm/6 underline underline-offset-2"
                        (click)="goToProducts(categoria.uuid!)"
                        >{{ categoria.name }}</a
                      >
                    </li>
                  }
                </ul>
              </div>
              <div class="mt-10 md:mt-0">
                <h3 class="w-fit border-b-1 pb-2 text-xl font-semibold">
                  {{ "footer.Other" | translate }}
                </h3>
                <ul role="list" class="mt-3 space-y-2">
                  <li>
                    <a
                      routerLink="privacy"
                      class="text-sm/6 underline underline-offset-2"
                      (click)="scrollToTop()"
                      >{{ "footer.PrivacyPolicy" | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      routerLink="terms-and-conditions"
                      class="text-sm/6 underline underline-offset-2"
                      (click)="scrollToTop()"
                      >{{ "footer.TermsAndConditions" | translate }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="md:grid md:grid-cols-2 md:gap-4 lg:gap-8">
              <div>
                <h3 class="w-fit border-b-1 pb-2 text-xl font-semibold">
                  {{ "footer.ContactUs" | translate }}
                </h3>
                <ul role="list" class="mt-3 space-y-2">
                  <li>
                    <a class="block truncate text-sm/6"> Via Roma 51, 64100 Teramo (TE) </a>
                  </li>
                  <!-- LINK A FORM CONTATTACI -->
                  <li>
                    <a
                      routerLink="contacts"
                      class="text-sm/6 underline underline-offset-2"
                      (click)="scrollToTop()"
                    >
                      {{ "footer.ContactForm" | translate }}
                    </a>
                  </li>
                  <li>
                    <a
                      routerLink="footer-info/aiuto-servizio-clienti"
                      class="text-sm/6 underline underline-offset-2"
                      (click)="scrollToTop()"
                    >
                      {{ "footer.Support" | translate }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-10 md:mt-0">
                <h3 class="w-fit border-b-1 pb-2 text-xl font-semibold">
                  {{ "footer.Begin" | translate }}
                </h3>
                <ul role="list" class="mt-3 space-y-4">
                  <li>
                    <span class="text-sm/6">{{ "footer.NoLogin1" | translate }}</span>
                  </li>
                  @if (!sessionService.user()) {
                    <li>
                      <button
                        pButton
                        [outlined]="true"
                        severity="secondary"
                        class="s-button-secondary rounded-xl border-3"
                        (click)="goToRegistrati()"
                      >
                        {{ "footer.NoLogin4" | translate }}
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card footer-card my-8 flex flex-col gap-1 rounded-md px-4 py-3">
          <p class="text-primary text-lg font-bold">
            {{ "footer.CardTitle" | translate }}
          </p>
          <a
            class="cursor-pointer text-sm font-semibold text-blue-800 underline"
            (click)="readMoreInfo()"
            >{{ "footer.MoreInfo" | translate }}</a
          >
          <div class="my-1 flex items-center justify-between">
            <img
              class="w-full object-contain"
              [src]="'assets/images/logo-card-footer.svg'"
              alt="Logo Commissario Straordinario Ricostruzione Sisma 2016, Logo Next appennino Fondo complementare aree sisma 2009-2016, Logo Presidenza del consiglio dei Ministri - Struttura di Missione Sisma 2009"
            />
          </div>
        </div>
        <p class="mt-8 text-center text-sm/6 text-gray-400">
          Copyright © 2025 Powered by Meccatronica S.r.l. Tutti i diritti riservati.
        </p>
      </div>
    </footer>
  `,
  styles: ``,
  imports: [TranslateModule, ButtonDirective, AsyncPipe, RouterModule],
})
export class FooterComponent implements OnInit {
  sessionService = inject(SessionService);
  categories$: Observable<CategoryRecord[]> = this.catalogService.categories$;
  theme = "LIGHT";
  constructor(
    private router: Router,
    private catalogService: CatalogService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.themeService.theme.subscribe((value) => (this.theme = value));
  }

  goToRegistrati(): void {
    this.scrollToTop();
    if (!this.sessionService.user()) {
      this.router.navigate(["/registration"]);
    } else {
      this.router.navigate(["/account"]);
    }
  }

  readMoreInfo(): void {
    this.scrollToTop();
    this.router.navigateByUrl("/loan");
  }

  goToProducts(category: string): void {
    this.router.navigate(["/category/", category]);
  }

  scrollToTop() {
    window.scroll(0, 0);
  }
}
